import { writable } from "svelte/store";

export const activeOverlay = writable(null);
export const userState = writable({});
